import { useNavigate, useRouterState } from "@tanstack/react-router";

import { trpc } from "@blis/trpc/react";

import { ConfirmPrompt } from "@/components/ConfirmPrompt";
import { toast } from "@/components/ui/toast";
import { useDialogProps } from "../detail/state";

export function DeleteDialog({
  accession,
}: {
  accession: { id: number; subjectId: number };
}) {
  const navigate = useNavigate();
  const dialogProps = useDialogProps("delete");
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const deleteAccession = trpc.accession.delete.useMutation({
    onSuccess() {
      toast.success("Accession deleted");
      if (pathname.startsWith("/subjects")) {
        navigate({
          to: "/subjects/$id/accession",
          params: { id: accession.subjectId },
          search: (prev) => ({
            ...prev,
            accessionId: undefined,
          }),
          replace: true,
        });
      } else {
        navigate({ to: "/accessions" });
      }
    },
    onError(err) {
      toast.error("Error deleting accession", {
        description: err.message,
      });
    },
  });

  const deleteClicked = async () => {
    await deleteAccession.mutateAsync(accession.id);
    dialogProps.onOpenChange?.(false);
  };

  return (
    <ConfirmPrompt
      {...dialogProps}
      title="Delete accession"
      message="Are you sure you want to delete this accession?"
      warningText="This is a destructive action. Deleting will remove all traces of this accession from the system (except audit logs). Consider cancelling instead."
      onConfirm={deleteClicked}
      loading={deleteAccession.isPending}
      danger
    />
  );
}
